import React, { useEffect, useRef, useState } from "react";
import ConditionalRender from "../ConditionalRender";
import { Tooltip } from "antd";
import styles from "./DescriptionCell.module.scss";
import clsx from "clsx";

interface DescriptionCellProps {
  text: string | null;
  disabled: boolean
}

const DescriptionCell: React.FC<DescriptionCellProps> = ({ text, disabled = false }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (textRef.current) {
        const isOverflow =
          textRef.current.scrollWidth > textRef.current.clientWidth;
        setIsOverflowing(isOverflow);
      }
    };

    checkOverflow();
    const timeoutId = setTimeout(checkOverflow, 100);

    const resizeObserver = new ResizeObserver(checkOverflow);
    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }
    return () => {
      clearTimeout(timeoutId);
      resizeObserver.disconnect();
    };
  }, [text]);

  return (
    <ConditionalRender
      visible={text !== null}
      fallback={<div className={styles.descriptionNullWrapper}>-</div>}
    >
      <Tooltip
        placement="top"
        title={isOverflowing ? text : ""}
        overlayClassName={styles.toolTipStyle}
      >
        <div className={clsx(
          styles.ellipsisContainer, {
            [styles.disabledColor]: disabled,
          }
          )} ref={textRef}>
          {text}
        </div>
      </Tooltip>
    </ConditionalRender>
  );
};

export default DescriptionCell;
